/** Mirrors BE `RideRouteCompletionStatusEnum` — rides grid "Route Completion Status" column (RYDE-8037). */
export enum RideRouteCompletionStatusEnum {
  NotDone = "NotDone",
  Partial = "Partial",
  Completed = "Completed",
}
